import {ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output} from "@angular/core";
import {CommonModule} from "@angular/common";
import {WindowRefService} from "../../../services/window-ref.service";
import {EventBusService} from "../../../services/event-bus.service";
import {OnDestroy$} from "@pdtec/ngx-observable-lifecycle";

@Component({
  selector: 'ng-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
  imports: [CommonModule],
  standalone: true
})
export class NgModalComponent extends OnDestroy$ implements OnInit {
  @Input() configuration: {content: {htmlDetachSelectorId: string}};

  constructor(
    private windowService: WindowRefService,
    private eventBusService: EventBusService,
  ) {
    super();
  }

  private title: string;

  ngOnInit() {
    this.eventBusService.changeModalTitle$
      .subscribe((title) => {
        this.title = title;
        this.setTitle();
      });
  }

  setTitle() {
    this.windowService.nativeWindow.modal
      .setTitle('#' + this.configuration['content']['htmlDetachSelectorId'], this.title);
  }

  open() {
    const defaultConfig = this.defaultConfiguration();
    const userConfig = this.configuration;

    const mergedConfig = {
      ...defaultConfig,
      ...userConfig,
      header: {
        ...defaultConfig.header,
        ...(userConfig['header'] || {}),
      },
      content: {
        ...defaultConfig.content,
        ...(userConfig['content'] || {}),
      },
      onBeforeClose: (modal) => {
        // Выполняем дефолтный onBeforeClose
        if (defaultConfig.onBeforeClose) {
          defaultConfig.onBeforeClose(modal);
        }
        // Если пользовательская функция onBeforeClose существует в userConfig
        if (typeof userConfig['onBeforeClose'] === 'function') {
          userConfig['onBeforeClose'](modal);
        }
      },
      onAfterShow: (modal) => {
        // Выполняем дефолтный onAfterShow
        if (defaultConfig.onAfterShow) {
          defaultConfig.onAfterShow(modal);
        }
        // Если пользовательская функция onAfterShow существует в userConfig
        if (typeof userConfig['onAfterShow'] === 'function') {
          userConfig['onAfterShow'](modal);
        }
      }
    };

    this.windowService.nativeWindow.modal.open(mergedConfig);

    this.setTitle();
  }



  defaultConfiguration() {
    return {
      header: {
        title: this.title,
        titleAlign: 'center',
      },
      footer: true,
      content: {
        htmlDetachSelectorId: '',
      },
      type: 'bottom',
      onAfterShow: (modal) => {
        this.eventBusService.isOpenModal$.next(modal);
      },
      onBeforeClose: (modal) => {
        this.eventBusService.isCloseModal$.next(modal);
      }
    };
  }
}
